import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiDisclaimerModalComponent } from '../ai-disclaimer-modal/ai-disclaimer-modal.component';
import { LocalizationPipe } from '@abp/ng.core';
@Component({
  selector: 'app-footer',
  imports: [LocalizationPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  constructor(private modalService: NgbModal) {}
  openAIDisclaimer() {
    this.modalService.open(AiDisclaimerModalComponent, {
      size: 'lg',
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
  }
}
